





























import { Component, Model, Prop, Vue, Watch } from 'vue-property-decorator';
import { tagWebservice } from '@/webservices/tag';
import type { Tag } from '@/models/tag';

@Component({
    name: 'TagSelect',
})
export default class TagSelect extends Vue {
    @Model('input') private value!: Tag;

    private tags = new Array<Tag>();
    private selectedTag = {} as Tag;
    private allTags: Tag = {} as Tag;

    @Watch('value', { immediate: true, deep: true })
    private onValueChange(newValue: Tag) {
        if (newValue !== this.selectedTag) {
            this.selectedTag = newValue;
        }
    }

    // Forward `multiselect` input directly to parent v-model
    private onInternalInput(newValue: Tag) {
        this.$emit('input', newValue);
    }

    private mounted() {
        this.loadTags();
    }

    private loadTags() {
        tagWebservice
            .load()
            .then((response) => {
                this.tags = response.data;

                this.allTags.id = 0;
                this.allTags.title = this.$t('keywords.allTags').toString();

                if (!this.value || !this.value.id) {
                    this.selectedTag = this.allTags;
                    // ensure parent receives default on initial load
                    this.$emit('input', this.selectedTag);
                }

                // Add it in the front of the array
                this.tags.unshift(this.allTags);
            })
            .catch((error) => {
                console.error(error);
            });
    }
}
